<div class="report-error-container">
  @for (error of errors(); track error; let last = $last) {
    <mat-list>
      <div class="error-holder">
        <mat-icon>cancel</mat-icon>
        <mat-list-item>{{ error }}</mat-list-item>
      </div>
      @if (!last) {
        <mat-divider></mat-divider>
      }
    </mat-list>
  }
</div>
